// extracted by mini-css-extract-plugin
module.exports =  {"text":"SocialProofText-SocialProofText-text-a5a14ca1","noMargin":"SocialProofText-SocialProofText-noMargin-d1720741"};